import * as React from "react"
import { Box } from "@mui/material"

import { HierarchicalTextBlock, ImageSkuBlock } from "@components"


export default function productSkuColumn() {
    return [{
        name: "category", label: "Category",
        options: { display: "excluded" }
    }, {
        name: "brand", label: "Brand",
        options: { display: "excluded" }
    }, {
        name: "skuName", label: "SKU",
        options: {
            display: "excluded",
            filterType: "textField"
        }
    }, {
        name: "ean", label: "EAN",
        options: {
            display: "excluded",
            filter: false
        }
    }, {
        name: "skuName", label: "Product SKU",
        options: {
            filter: false,
            customBodyRowRender: (value, row) => <Box
                display="flex"
                justifyContent="flex-start"
                alignItems="center"
                gap={2}
            >
                <Box>
                    <ImageSkuBlock imageURL={row.imageURL} />
                </Box>
                <Box display="flex" flexDirection="column">
                    <HierarchicalTextBlock
                        supertitle="Category: "
                        supertitleValue={row.category}
                        title="Brand: "
                        titleValue={row.brand}
                        subtitle="SKU: "
                        subtitleValue={value}
                    />
                    <HierarchicalTextBlock title="EAN: " titleValue={row.ean} />
                </Box>
            </Box>
        }
    }]
}